/**
 * Appends a copy of the store into the window object, useful to preserve the store between hot-reloads
 * @param {Object} store - object pointing to your store
 */
function addMemory(store) {
    if (window.STATE) store.setState(window.STATE);
    store.subscribe(state => {
        window.STATE = state;
    });
}

export default addMemory;
